var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2369CC",
    width: "100px",
    height: "100px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#2369CC",
    transform: "rotate(0)",
    strokeWidth: 0.00030000000000000003,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.99 6.437c-.58-.58-1.54-.58-2.12 0l-.433.432c-.58.58-.58 1.54 0 2.12l1.573 1.574c.582.58 1.54.58 2.122 0l.432-.433c.58-.58.58-1.538 0-2.12L27.99 6.437zm-.706.707l1.573 1.573c.202.202.202.505 0 .707l-.433.433c-.2.202-.505.202-.707 0l-1.573-1.573c-.202-.202-.202-.505 0-.707l.433-.433c.202-.202.505-.202.707 0zm-3.41 1.86c-.3-.024-.666.06-.938.334l-10.29 10.308c-.187.19-.385.386-.503.692-.117.306-.142.64-.142 1.162V23c0 .505.43 1 1 1h1.5c.524 0 .865-.03 1.17-.148.306-.12.503-.317.684-.498l10.29-10.31c.495-.496.45-1.256 0-1.706l-2-2c-.212-.21-.47-.31-.77-.334zm.062 1.04l2 2c.038.038.076.218 0 .294l-10.29 10.308c-.18.18-.233.233-.337.274-.105.04-.332.08-.81.08H13v-1.5c0-.48.038-.705.077-.805.038-.1.09-.153.277-.34l10.29-10.31c.09-.09.247-.045.292 0zM4.5 11h13c.277 0 .5.223.5.5s-.223.5-.5.5h-13c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zm0-3h13c.277 0 .5.223.5.5s-.223.5-.5.5h-13c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zm0-3h13c.277 0 .5.223.5.5s-.223.5-.5.5h-13c-.277 0-.5-.223-.5-.5s.223-.5.5-.5zm-3-5C.678 0 0 .678 0 1.5v27c0 .822.678 1.5 1.5 1.5h19c.822 0 1.5-.678 1.5-1.5v-8c0-.668-1-.648-1 0v8c0 .286-.214.5-.5.5h-19c-.286 0-.5-.214-.5-.5v-27c0-.286.214-.5.5-.5h19c.286 0 .5.214.5.5v7c0 .672 1 .648 1 0v-7c0-.822-.678-1.5-1.5-1.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.7139809d082e1c02717bc7ce636844dd.svg";
export { ForwardRef as ReactComponent };